import { configureStore } from '@reduxjs/toolkit';
import analysisReducer from './analysisSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    analysis: analysisReducer,
    auth: authReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;